/**
 * WISHLIST 2023
 * 
 * Gestion wishlist unique part/pro
 * Gestion multilist en pro connecté
 * 
 * wishlist stockée en localstorage pour la wishlist unique et
 * en DB pour la multiliste pro connecté
 */

import $ from "jquery";
import { debounce } from 'throttle-debounce';
import tableSort from "table-sort-js/table-sort.js";
import { strings } from "../../helpers/strings.js";
import { tooltip } from "../../components/tooltip.js";
import { importLib } from "../../helpers/async-libs.js";

const utils               = require('./modules/utils').default;
const loader              = require("./modules/loader.js").default;
const trackers            = require("./modules/trackers.js").default;
const templates           = require("./modules/templates.js").default;
//const debugTools          = require("./modules/debug-tools.js").default;

const WL                  = require("./modules/wl/WL.js").default;
const WLCreate            = require("./modules/wl/WL-create").default;
const WLDelete            = require("./modules/wl/WL-delete").default;
const WLDuplicate         = require("./modules/wl/WL-duplicate").default;
const WLExport            = require("./modules/wl/WL-export").default;
const WLFileTechnic       = require("./modules/wl/WL-file-technic").default;
const WLListShare         = require("./modules/wl/WL-list-share").default;
const WLImport            = require("./modules/wl/WL-import.js").default;
const WLProductDelete     = require("./modules/wl/WL-product-delete").default;
const WLProductQuantity   = require("./modules/wl/WL-product-quantity").default;
const WLProductMove       = require("./modules/wl/WL-product-move").default;
const WLProductSelection  = require("./modules/wl/WL-product-selection").default;
const WLPrint             = require("./modules/wl/WL-print").default;
const WLRename            = require("./modules/wl/WL-rename").default;

const DOCS                = require("./modules/docs/DOCS.js").default;
const DOCSDelete          = require("./modules/docs/DOCS-delete.js").default;
const DOCSSearch          = require("./modules/docs/DOCS-search.js").default;
const DOCSSelection       = require("./modules/docs/DOCS-selection.js").default;



var wishListManager = (function() {
    const LOG = true;
    
    
    const DOM_WISHLIST_ALL_LISTS = '.js-wishlist-all-lists';
    const DOM_WISHLIST_ALL_LISTS_COUNT = '.js-wishlist-all-lists-count';

    const DOM_WISHLIST_LIST_DETAILS = '.js-wishlist-list-details';
    const DOM_WISHLIST_LIST_DETAILS_PRDUCTS = '.js-wishlist-list-details-products';
    const DOM_WISHLIST_LIST_TITLE = '.js-wishlist-list-title';
    const DOM_WISHLIST_GRAND_TOTAL = '.js-wishlist-grand-total';
    const DOM_WISHLIST_REDUCE = '.js-wishlist-reduce';
    const DOM_WISHLIST_REDUCE_TOTAL = '.js-wishlist-reduce-total';
    const DOM_WISHLIST_PRODUCT_QUANTITY = '.js-wishlist-product-quantity';
    const DOM_WISHLIST_PRODUCT_TOTAL_PRICE = '.js-wishlist-product-total-price';
    const DOM_WISHLIST_PRODUCT_SELECTION = '.js-wishlist-product-selection';
    const DOM_WISHLIST_DOCS_ADDTO = '.js-documents-add-to';
    const DOM_WISHLIST_NOTIFICATION = '.js-wishlist-notification';

    const DOM_DOCUMENTS_TITLE_COUNT = '.js-documents-title-count';
    const DOM_DOCUMENTS_LIST = '.js-documents-list';

    const DOM_USER_LOGOUT = '.js-user-logout';
    const POPIN_LOGOUT = 'popin-logout';
    const DOM_POPIN_LOGOUT_POPIN = `[data-js-dialog-id="${POPIN_LOGOUT}"]`;

    const WLM_OBSOLETE_PRODUCTS_REMOVED = 'Il semblerait que certains produits n\'existent plus et ont été supprimé de votre liste.';
    let userLogged = false;

    /**
     * LOAD CAPTCHA
     */
    var loadCaptcha = function() {
        if (typeof captchsitekey != 'undefined') {
            $.getScript('https://www.google.com/recaptcha/api.js?render=explicit', function(){
                $('.g-recaptcha').each(function (index, el) {
                    var _this = $(this);
                    var $grecaptcha_response = _this.children('.g-recaptcha-response');
                    grecaptcha.ready(function() {
                        grecaptcha.execute(captchsitekey, {action: 'submit/wishlist'}).then(function(token) {
                            // Add your logic to submit to your backend server here.
                            $grecaptcha_response.val(token);
                            // _this.append('<input type="hidden" id="g-recaptcha-response" class="g-recaptcha-response" value="'+token+'" />')
                            _this.closest('form').find('#submitprint').removeClass('captcha-invalid');
                        });
                    });

                });
            });
        } else {
            console.error('variable captchsitekey undefined');
        }
    };
    const userLogout = () => {
        $(DOM_USER_LOGOUT).on('click', (event) => {
            $(DOM_POPIN_LOGOUT_POPIN).addClass('active');
            $(DOM_POPIN_LOGOUT_POPIN).find('.js-logout-btn').attr('href', $(event.currentTarget).attr('href'));
            event.stopPropagation();
            event.preventDefault();
        })
    }
    /**
     * ANIMATIONS INIT
     */
    const animationsInit = () => {
        document.addEventListener('ANIMATION_PRODUCT_REMOVE', (event) => {
            let $product = utils.getDomProductFromId(event.detail.id);
            const categoryId = $product.attr('data-product-category-id');
            const productFromCat = $(`.js-wishlist-product[data-product-category-id=${categoryId}]`);
            if (productFromCat.length === 1) {
                const $catRow = $(`.c-table__row--category#${categoryId}`);
                if ($catRow) {
                    $catRow.addClass('c-table__row--animation--hidden');
                    setTimeout(() => {
                        $catRow.remove();
                    },350);
                }
            }
            $product.addClass('c-table__row--animation--hidden');
            setTimeout(() => {
                $product.remove();
            },350);
        });
        document.addEventListener('ANIMATION_LIST_REMOVE', (event) => {
            let $list = utils.getDomListFromId(event.detail.listId);
            $list.addClass('c-table__row--animation--hidden');
            setTimeout(() => {
                $list.remove();
            },350);
        });
        document.addEventListener('ANIMATION_DOCS_REMOVE', (event) => {
            let $doc = utils.getDomDocFromId(event.detail.id, event.detail.groupId);
            $doc.addClass('c-table__row--animation--hidden');
            setTimeout(() => {
                if ($doc.parent().children().length === 1) {
                    $doc.closest('.js-docs-group').slideUp('normal', () => {
                        $doc.closest('.js-docs-group').remove();
                    });
                }
                $doc.remove();
            },350);
        }); 
    };
    /**
     * MOBILE SHOW BUTTONS
     * 
     * affichage des buttons dans la 
     * listes de wishlist de l'espace 
     * mon compte
     * @param {event} event 
     */
    const mobileShowButtons = (event) => {
        if (!utils.isDesktop()) {
            event.preventDefault();
            if ($(event.currentTarget).parent().hasClass('open')) {
                $(event.currentTarget).parent().toggleClass('open');
            } else {
                $(`${DOM_WISHLIST_ALL_LISTS} tbody tr.open`).removeClass('open');
                $(event.currentTarget).parent().toggleClass('open');
            }
        }
    };
    /**
     * MOBILE SHOW TOOLS
     * 
     * affichage des buttons dans la 
     * listes de wishlist de l'espace 
     * mon compte
     * @param {event} event 
     */
    const mobileShowTools = (event) => {
        event.preventDefault();
        if (!utils.isDesktop()) {
            $(event.currentTarget).toggleClass('open');
        }
    };
    /**
     * TABLE SORT INIT
     * 
     * initialisation de la lib de table sort
     * + gestion des class sort
     */
    const tableSortInit = () => {
        tableSort();
        $(`${DOM_WISHLIST_ALL_LISTS} .table-sort thead th`).off().on('click', (event) => {
            if ($(event.currentTarget).hasClass('sort')) {
                $(event.currentTarget).toggleClass('sort');
                $(event.currentTarget).find('i').toggleClass('c-icon--rotate-top');
            } else {
                $(`${DOM_WISHLIST_ALL_LISTS} .table-sort thead th.sort`).find('i').toggleClass('c-icon--rotate-top');
                $(`${DOM_WISHLIST_ALL_LISTS} .table-sort thead th.sort`).removeClass('sort');
                $(event.currentTarget).toggleClass('sort');
                $(event.currentTarget).find('i').toggleClass('c-icon--rotate-top');
            }
        });
    };
    /**
     * GET OBSOLETE AND ENABLED PRODUCTS
     * 
     * split du tableau de produit entre
     * les produits obsolètes et actifs
     * @param {array} products 
     * @returns {object}
     */
    const getObsoleteAndEnabledProducts = (products) => {
        let obsolete = [];
        let enabled = [];
        products.forEach((product) => {
            if (product.error !== undefined){
                obsolete.push(parseInt(product.ean));
            } else {
                enabled.push(product);
            }
        });
        return {enabled, obsolete};
    };
    /**
     * SHOW WISHLIST SHARE CONTACT PRO
     * 
     * gestion de l'affichage du bloc contact pro
     */
    const showWishlistShareContactPro = (() => {
        let wishlistGrandTotal = WL.getWishlistGrandTotal();
        let wishlistId = WL.getCurrentWishlist();
        let contactProBloc = $('.js-wishlist-share-pro-block');
        if ( parseInt(wishlistGrandTotal) >= 700 && utils.isProContext ) {
            contactProBloc.each(function() {
                let url = new URL($('.js-wishlist-share-pro-link').attr('href'), window.location.origin);
                let href = `${url.origin}${url.pathname}?wishlistid=${wishlistId}`;
                $(this)
                    .removeClass("u-hidden")
                    .find('.js-wishlist-share-pro-link').attr('href', href);
            });
        } else {
            contactProBloc.each(function() {
                $(this).addClass("u-hidden");
            });
        }
    });
    /**
     * UPDATE WISHLIST GRAND TOTALS
     * 
     * mise à jour DOM des champs totaux
     */
    const updateWishlistGrandTotals = () => {
        let wishlistGrandTotal = WL.getWishlistGrandTotal();
        let wishListReduction = ((wishlistGrandTotal * WL.getWishlistReduction()) / 100).toFixed(2);
        let wishlistReduceTotal = wishlistGrandTotal - wishListReduction;
        $(DOM_WISHLIST_GRAND_TOTAL).text(utils.getFormatedPrice(wishlistGrandTotal));
        $(DOM_WISHLIST_REDUCE_TOTAL).text(utils.getFormatedPrice(wishlistReduceTotal));
    };
    /**
     * UPDATE WISHLIST REDUCTION
     * 
     * mise à jour DOM du champ réduction
     */
    const updateWishlistReduction = () => {
        let reduce = WL.getWishlistReduction();
        $(DOM_WISHLIST_REDUCE).val(reduce);
    };
    /**
     * DISABLE SIDEBAR BUTTONS
     * 
     * Si la liste est vide, on disable les 
     * boutons de la sidebar
     */
    const disableSidebarButtons = () => {
        if (WL.isWishlistsContextHasProducts()) {
            $('.m-wishlist__sidebar .c-button').removeAttr('disabled');
        } else {
            $('.m-wishlist__sidebar .c-button').attr('disabled', 'disabled');
        }
    }
    /**
     * WISHLIST NOTIFICATION TOGGLE CLASS
     * 
     * Etat empty not empty du btn d'acces à la wishlist 
     * du header
     */
    const wishlistNotificationToggleClass = () => {
        $(`${DOM_WISHLIST_NOTIFICATION} .js-wishlist-notification-empty`).toggleClass('u-hidden', WL.isWishlistsContextHasProducts());
        $(`${DOM_WISHLIST_NOTIFICATION} .js-wishlist-notification-not-empty`).toggleClass('u-hidden', !WL.isWishlistsContextHasProducts());
    }
    /**
     * SET WISHLIST LIST TITLE
     * 
     * affichage du bloc title WL via template
     */
    const setWishlistListTitle = () => {
        utils.dispatchCustomEvent('TEMPLATE_WISHLIST_LIST_TITLE', {target: DOM_WISHLIST_LIST_TITLE, name: WL.getWishlistName(), count: WL.getProductCount()});
    };
    /**
     * SET WISHLISTS ALL LISTS TITLE COUNT
     * 
     * definition du nombre de liste total
     * dans le titre de la liste de WL
     * de l'espace connecté
     */
    const setWishlistsAllListsTitleCount = () => {
        $(DOM_WISHLIST_ALL_LISTS_COUNT).text(WL.getWishlistAllListsCount());
    };
    /**
     * SET DOCS TITLE COUNT
     * 
     * définition du nombre total de
     * documents dans le title de la
     * liste de documents de l'espace
     * connecté
     */
    const setDocsTitleCount = () => {
        $(DOM_DOCUMENTS_TITLE_COUNT).text(DOCS.getDocsCount());
    };
    /**
     * WISHLIST CHANGE LISTENER INIT
     * 
     * ecouteur de changement de la WL
     */
    const wishlistChangeListenerInit = () => {
        /**
         * WISHLIST HAS CHANGED
         * 
         * changement de l'objet WL - on enregistre
         * la nouvelle version puis on mets à jour
         * les différents éléments de DOM
         */
        document.addEventListener('WISHLIST_HAS_CHANGED', debounce(500, (event) => {
            WL.saveWishlists().then(() => {
                if ($(DOM_WISHLIST_LIST_DETAILS).length){
                    // MAJ DOM page WL details
                    updateWishlistGrandTotals();
                    updateWishlistReduction();
                    showWishlistShareContactPro();
                    setWishlistListTitle();
                    if (WL.getProductCount() === 0) {
                        utils.dispatchCustomEvent('TEMPLATE_WISHLIST_EMPTY', {target: DOM_WISHLIST_LIST_DETAILS});
                    }               
                }
                if ($(DOM_WISHLIST_ALL_LISTS).length && userLogged) {
                    // MAJ DOM page list de WL
                    setWishlistsAllListsTitleCount();
                    wishlistAllListsGeneration();
                }

                wishlistNotificationToggleClass();
                utils.debug('WISHLIST HAS CHANGED', WL._WL); 
                if (event.detail.updateList !== undefined) {
                    utils.dispatchCustomEvent('WISHLIST_UPDATE', {name: event.detail.updateList});
                }

            }).catch((error) => {
                utils.dispatchCustomEvent('TEMPLATE_ERROR', {error});
            }).finally(() => {
                disableSidebarButtons();
            });
        }));
        /**
         * WISHLIST UPDATE
         * 
         * modification du WL spécifique demandant 
         * une MAJ du champ "total (montant)" et "update_at (Date de modification)"
         * en DB.
         */
        document.addEventListener('WISHLIST_UPDATE', debounce(500, (event) => {
            const wishlistName = event.detail.name;
            WL.updateWishlist(wishlistName).then(() => {
                utils.debug('WISHLIST UPDATE SUCCESS', wishlistName); 
            }).catch((error) => {
                utils.dispatchCustomEvent('TEMPLATE_ERROR', {error});
            }).finally(() => {
            });
        }));
        /**
         * WISHLIST DETAILS CHANGED
         * 
         * changement de la liste destails, on charge
         * la nouvelle version puis on mets à jour
         * les différents éléments de DOM
         */
        document.addEventListener('WISHLIST_DETAILS_CHANGED', debounce(500, (event) => {
            WL.getWishlistDetailsProducts().then((data) => {
                wishlistListProductsGeneration(data.datas.elements);
            }).catch(() => {
                utils.dispatchCustomEvent('TEMPLATE_WISHLIST_EMPTY', {target: DOM_WISHLIST_LIST_DETAILS});
            }).finally(() => {
                disableSidebarButtons();
            });
        }));
        /**
         * WISHLIST PRODUCT QUANTITY CHANGED
         * 
         * changement de l'objet WL - on mets à jour
         * les différents éléments de DOM
         */
        document.addEventListener('WISHLIST_PRODUCT_QUANTITY_CHANGED', debounce(500, (event) => {
            if ($(DOM_WISHLIST_LIST_DETAILS).length){
                // MAJ DOM page WL details
                let $product = utils.getDomProductFromId(event.detail.id);
                $product.find(DOM_WISHLIST_PRODUCT_QUANTITY).val(event.detail.quantity);
                $product.find(DOM_WISHLIST_PRODUCT_TOTAL_PRICE).find('span.js-wishlist-product-total-price-value').text(event.detail.totalPrice);
            }
        }));
        /**
         * DOCUMENTS HAS CHANGED
         * 
         * changement de l'objet DOCS - on enregistre
         * la nouvelle version puis on mets à jour
         * les différents éléments de DOM
         */
        document.addEventListener('DOCUMENTS_HAS_CHANGED', debounce(500, (event) => {
            DOCS.docsSave().then(() => {
                if ($(DOM_DOCUMENTS_LIST).length && userLogged) {
                    setDocsTitleCount();
                    if (DOCS.getDocsCount() === 0) {
                        utils.dispatchCustomEvent('TEMPLATE_DOCS_EMPTY', {target: DOM_DOCUMENTS_LIST});
                    }
                }
                utils.debug('DOCUMENTS HAS CHANGED', DOCS.getAllDocs()); 
            }).catch((error) => {
                utils.dispatchCustomEvent('TEMPLATE_ERROR', {error});
            }).finally(() => {
            });
        }));
    };
    /**
     * WISHLIST LIST PRODUCTS EVENTS
     * 
     * initialisation de bind et des modules
     * pour le fonctionnement de la partie 
     * liste de products details
     */
    const wishlistListProductsEvents = () => {
        // modification de l'input Remise
        $(DOM_WISHLIST_REDUCE).off().on('change keyup', (event) => {
            let reduce = parseInt($(event.currentTarget).val());
            let productID = parseInt($(event.currentTarget).data('id'));
            reduce = reduce >= 0 ? reduce : 0;
            reduce = reduce <= 60 ? reduce : 60;
            WL.setReduction(reduce);
        });
        tooltip.reload();
        importLib('table.js').then((table) => {
            table.reload();
        });
        WLProductQuantity.init();
        WLProductDelete.init();
        WLProductMove.init();
        WLCreate.init();
    };
    /**
     * WISHLIST LIST PRODUCTS GENERATION
     * 
     * génération via templates de la 
     * liste de produits
     * @param {array} elements 
     */
    const wishlistListProductsGeneration = (elements) => {
        let products = getObsoleteAndEnabledProducts(elements);
        if (products.obsolete.length > 0) {
            // si des produits obsolète => remove + notification
            WL.removeFromWishlist(products.obsolete).then(() => {
                utils.dispatchCustomEvent('NOTIFICATION_DEFAULT', {content:WLM_OBSOLETE_PRODUCTS_REMOVED})
            });
        }
        if (products.enabled.length > 0) {
            
            // Sort products by category
            products.enabled.sort((a, b) => {
                const categoryA = (a.category || '').toLowerCase();
                const categoryB = (b.category || '').toLowerCase();
                return categoryA.localeCompare(categoryB);
            });
            
            // si produits enabled => génération du DOM
            utils.dispatchCustomEvent('TEMPLATE_WISHLIST_LIST_DETAILS', {target: DOM_WISHLIST_LIST_DETAILS});
            products.enabled.forEach((product) => {
                let quantity = WL.getProductQuantity(product.ean);
                let data = {
                    brand: product.brand,
                    category: product.category,
                    categoryID: `wishlist-category-${utils.slug(product.category)}`,
                    categoryUrl: product.categoryUrl,
                    categoryForAttribute: strings.quoteAttr(product.category) ||  "",
                    documentation: product.documentation,
                    ean: product.ean,
                    href: product.href,
                    name: product.label,
                    nameForAttribute: strings.quoteAttr(product.label),
                    media: product.media,
                    price: product.price,
                    range: product.range,
                    reference: product.ref,
                    type: product.type,
                    quantity: quantity,
                    showPrice: product.price === 0 ? 'disabled' : 'enabled',
                    totalPrice: utils.getFormatedPrice(quantity * product.price),
                    formatedPrice: utils.getFormatedPrice(product.price),
                };
                WL.saveCurrentWishlistProductData(data);
                utils.dispatchCustomEvent('TEMPLATE_WISHLIST_LIST_DETAILS_PRODUCTS', {target: DOM_WISHLIST_LIST_DETAILS_PRDUCTS, data});
            })
            wishlistListProductsEvents();
            utils.dispatchCustomEvent('WISHLIST_HAS_CHANGED', {event: 'init chargement produit'});

        } else {
            // affichage du template de liste vide
            utils.dispatchCustomEvent('TEMPLATE_WISHLIST_EMPTY', {target: DOM_WISHLIST_LIST_DETAILS});
        }
    };
    /**
     * WISHLIST LIST ALL LISTS EVENTS
     * 
     * initialisation de bind et des modules
     * pour le fonctionnement de la partie 
     * liste des WL
     */
    const wishlistAllListsEvents = () => {
        tooltip.reload();
        importLib('table.js').then((table) => {
            table.reload();
        });
        WLRename.init();
        WLDuplicate.init();
        WLDelete.init();
        WLExport.init();
        // $(`${DOM_WISHLIST_ALL_LISTS} tbody tr td:not(.btn-wrapper)`).off().on('click', mobileShowButtons);
        $(`${DOM_WISHLIST_ALL_LISTS} tbody tr .wishlist--tools`).off().on('click', mobileShowTools);
        tableSortInit();        
    };
    /**
     * WISHLIST ALL LISTS GENERATION
     * 
     * génération via templates de la 
     * liste des WL
     */
    const wishlistAllListsGeneration = () => {
        let wishlists = WL.getWishlistAllLists();
        if (WL.getWishlistAllListsCount() !== 0) {
            utils.dispatchCustomEvent('TEMPLATE_WISHLIST_ALL_LISTS', {target: DOM_WISHLIST_ALL_LISTS});
            wishlists = Object.keys(wishlists).sort().reduce(
                (obj, key) => { 
                  obj[key] = wishlists[key]; 
                  return obj;
                }, 
                {}
            );
            for (const key in wishlists) {
                let data = {
                    name: wishlists[key].name,
                    id: key,
                    count: WL.getProductsQuantityTotal(key).toString(),
                    total: wishlists[key].total ? utils.getFormatedPrice(wishlists[key].total) : '-',
                    updated_at: wishlists[key].updated_at ? utils.getFormatedDate(wishlists[key].updated_at) : '-',
                };
                utils.dispatchCustomEvent('TEMPLATE_WISHLIST_ALL_LIST', {target: `${DOM_WISHLIST_ALL_LISTS} tbody`, data});
            };
            wishlistAllListsEvents();
            // utils.dispatchCustomEvent('WISHLIST_HAS_CHANGED', {event: 'init chargement Liste des wishlists'});
        } else {
            utils.dispatchCustomEvent('TEMPLATE_WISHLIST_EMPTY', {target: DOM_WISHLIST_ALL_LISTS});
        }
    };
    /**
     * DOCS LIST EVENTS
     * 
     * initialisation de bind et des modules
     * pour le fonctionnement de la partie 
     * liste de DOCS
     */
    const docsListEvents = () => {
        DOCSDelete.init();
    };
    /**
     * DOCS LIST GENERATION
     * 
     * Génération via templates du DOM
     * de la liste de DOCUMENTS
     */
    const docsListGeneration = () => {
        $(DOM_DOCUMENTS_LIST).empty();
        let docsGroup = DOCS.getAllDocs();
        if (docsGroup.length) {
            docsGroup.forEach((group) => {
                utils.dispatchCustomEvent('TEMPLATE_DOCS_GROUP', {target: DOM_DOCUMENTS_LIST, name: group.name, id: utils.slug(group.name), url: group.url});
                if (group.list.length) {
                    let target = `${DOM_DOCUMENTS_LIST} .js-docs-list[data-docs-group-id="${utils.slug(group.name)}"]`;
                    $(target).empty();
                    group.list.forEach((doc) => {
                        let data = {
                            name: doc.name,
                            id: doc.id,
                            type: doc.type,
                            url: doc.url,
                            imageSrc: doc.imageSrc,
                            imageExist: doc.imageSrc !== undefined ? 'no-icon' : 'no-image',
                            groupId: utils.slug(group.name),
                        }
                        utils.dispatchCustomEvent('TEMPLATE_DOC', {target, data});
                        
                        if (doc.imageSrc !== undefined) {
                            $(`${target} [data-doc-id="${data.id}"] .js-doc-icon`).remove();
                        } else {
                            $(`${target} [data-doc-id="${data.id}"] .js-doc-image`).remove();
                        }
                    });
                }
            });
            docsListEvents()
        } else {
            // si vide affichage du template docs vide
            utils.dispatchCustomEvent('TEMPLATE_DOCS_EMPTY', {target: DOM_DOCUMENTS_LIST});
        }
    };
    const TEMP_CREATION_WL = () => {
        // WL.createWishlist('test3');
        // WL.createWishlist('ma névelle wisl&s');
        // WL.addToWishlist([3245060997212,3414970467393], 'ma névelle wisl&s');
        // WL.addToWishlist([3245060997212,3414970467393, 3245060997205]);
        // console.log('getProduct', WL.getProduct(3245060997205));
        // WL.addToWishlist([3245060997212,3414970467393,3245060997700,3414970525604], 'test');
        // WL.addToWishlist([3414971437661,3414971437661,3292290503010]);
        // WL.addToWishlist([3292290503010]);
        // WL.removeFromWishlist([3414971437661,3292290503010], 'test');
        // WL.addToWishlist(3414970525604);
        // WL.addToWishlist([10]);
        // WL.isWishlistExist('test');
        // WL.saveWishlists();
        // WL.createWishlist('test2');
        // WL.addToWishlist([
        //     3245060997700,
        //     3245060997700,
        //     3414970525604,
        //     3414970525604,
        //     3245060999759,
        //     3245060999759,
        //     3245060997717,
        //     3245060997717,
        //     3245060997205,
        //     3245060997205,
        //     3245060997786,
        //     3245060997786,
        //     3245060997786,
        //     3245060997786
        // ], 'test2');
    }

    const checkRedisAvailability = () => {
        fetch("/services/redis/status").then((res) => res.json()).then((data) => {
            if(data.status == false){
                utils.dispatchCustomEvent("NOTIFICATION_REDIS_DOWN");
            }
        })

    }


    let init = function() {
        if ('localStorage' in window) { 
            window.WL = WL;
            userLogged = utils.userLogged();
            //debugTools.init();
            //notifications.init();
            loader.init();
            trackers.init();
            templates.init();
            WLListShare.init();
            wishlistChangeListenerInit();
            animationsInit();
            WL.setUserLogged(userLogged);
            WL.setCurrentWishlist();

            if(userLogged){
                checkRedisAvailability();
                userLogout();
            }
            /**
             * INITIALISATION DE LA PARTIE
             * WISHLIST NOTIFICATION HEADER
             */
            if (!$(DOM_WISHLIST_LIST_DETAILS).length
                || $(DOM_WISHLIST_ALL_LISTS).length
                || $(DOM_WISHLIST_PRODUCT_SELECTION).length){
                    WL.loadAllWishlists().then(() => {
                        wishlistNotificationToggleClass();
                    });
            }

            /**
             * INITIALISATION DE LA PARTIE
             * WISHLIST DETAILS
             */
            if ($(DOM_WISHLIST_LIST_DETAILS).length) {
                // affichage des details d'une WL
                // show LOADER
                utils.dispatchCustomEvent('LOADER');
                // Chargement des WL localStorage + DB
                WL.loadAllWishlists().then(() => {
                    // save des wl
                    WLFileTechnic.init();
                    // WL.addToWishlist(3414970525604);
                    //WL.saveWishlists();
                    // on défini la WL en cours
                    WL.setCurrentWishlist(utils.getWishlistId());
                    WL.getWishlistDetailsProducts().then((data) => {
                        wishlistListProductsGeneration(data.datas.elements);
                        WLPrint.init();
                        WLExport.init();
                        utils.dispatchCustomEvent('TRACKERS_WISHLIST_LOAD',{
                            name: WL._WL.currentWL,
                            type: utils.getContext(),
                            productsCount: window.WL.getProductsQuantityTotal(),
                            grandTotal: utils.getFormatedPrice(window.WL.getWishlistGrandTotal()),
                        });
                        WL.getWishlistFlattenProductsFromList(WL._WL.currentWL).then((products) => { 
                            utils.dispatchCustomEvent('TRACKERS_WISHLIST_CHECKOUT', {
                                listLabel: WL._WL.currentWL,
                                listCategory: utils.getContext(),
                                products
                            });
                        })
                    }).catch((error) => {
                        console.log('TEMPLATE_WISHLIST_EMPTY FAILED', error);
                        utils.dispatchCustomEvent('TEMPLATE_WISHLIST_EMPTY', {target: DOM_WISHLIST_LIST_DETAILS});
                        disableSidebarButtons();
                    }).finally(() => {
                        wishlistNotificationToggleClass();
                        setWishlistListTitle();
                        // chargement d'une WL partagée
                        WLListShare.loadSharedWishlist();
                        // hide loader
                        utils.dispatchCustomEvent('LOADER', {show:false});
                        //loadCaptcha();
                        /*setTimeout(function() {
                            setInterval(loadCaptcha, 10 * 1000); // fire every  sec
                        }, 10 * 1000);*/ // fire only one time after 10 sec
                    });
                });
            }
            /**
             * INITIALISATION DE LA PARTIE
             * ALL WISHLISTS
             */
            if ($(DOM_WISHLIST_ALL_LISTS).length) {
                utils.dispatchCustomEvent('LOADER');
                WL.loadAllWishlists().then(() => {
                    wishlistAllListsGeneration()
                    WLCreate.init();
                    WLImport.init();
                }).catch(() => {
                    
                }).finally(() => {
                    wishlistNotificationToggleClass();
                    setWishlistsAllListsTitleCount();
                    utils.dispatchCustomEvent('LOADER');
                });
            }
            /**
             * INITIALISATION DE LA PARTIE
             * SELECTION DE PRODUITS
             */
            if ($(DOM_WISHLIST_PRODUCT_SELECTION).length) {
                WL.loadAllWishlists().then(() => {
                    WLCreate.init();
                    WLProductMove.init();
                    WLProductSelection.init();
                }).catch(() => {
                }).finally(() => {
                    wishlistNotificationToggleClass();
                });
            }
            /**
             * INITIALISATION DE LA PARTIE
             * LIST DE DOCUMENTS
             */
            if ($(DOM_DOCUMENTS_LIST).length && userLogged) {
                utils.dispatchCustomEvent('LOADER');
                window.DOCS = DOCS;
                DOCS.docsLoad().then(() => {
                    docsListGeneration();
                    DOCSSearch.init();
                }).catch((error) => {
                    utils.dispatchCustomEvent('TEMPLATE_ERROR', {error});
                    utils.dispatchCustomEvent('TEMPLATE_DOCS_EMPTY', {target: DOM_DOCUMENTS_LIST});
                }).finally(() => {
                    setDocsTitleCount();
                    utils.dispatchCustomEvent('LOADER');
                });
            }
            /**
             * INITIALISATION DE LA PARTIE
             * SELECTION DE DOCUMENTS
             */
            if ($(DOM_WISHLIST_DOCS_ADDTO).length) {
                if (userLogged){
                    window.DOCS = DOCS;
                    DOCS.docsLoad().then(() => {
                        DOCSSelection.init();
                    }).catch((error) => {
                        utils.dispatchCustomEvent('TEMPLATE_ERROR', {error});
                    }).finally(() => {
                    });
                } else {
                    DOCSSelection.init();
                }
            }
        } else {
            pm.debug && console.error(`"LocalStorage" n'est pas supporté par le navigateur`);
        }
    };

    return {
        init: init
    }

})();

export default wishListManager; 
document.addEventListener("DOMContentLoaded", function() {
    wishListManager.init();
});
